import { create } from 'zustand';

// 创建状态存储
const useProductStore = create((set) => ({
  compareData: {
    // 比较的商品
    open: false,
    productVO: null,
    index: null,
    rs_log: null,
  },
  collectData: {
    // 收藏的商品
    open: false,
  },
  couponData: {
    // 优惠券的商品
    open: false,
    product: {},
  },
  arrivalNoticeData: {
    // 到货通知的商品
    open: false,
    product: {},
  },
  quotedPriceData: {
    // 报价商品的数据
    open: false,
    product: {},
  },
  datasheetData: {
    // 数据表的数据
    open: false,
    product: {},
  },
  compareList: [], // 保存的对比商品id
  currentTime: null, // 当前时间
  updateCompareData: (compareData) => set({ compareData }),
  updateCollectData: (collectData) => set({ collectData }),
  updateCouponData: (couponData) => set({ couponData }),
  updateArrivalNoticeData: (arrivalNoticeData) => set({ arrivalNoticeData }),
  updateQuotedPriceData: (quotedPriceData) => set({ quotedPriceData }),
  updateDatasheetData: (datasheetData) => set({ datasheetData }),
  updateCurrentTime: (currentTime) => set({ currentTime }),
  updateCompareList: (compareList) => set({ compareList }),
}));

export default useProductStore;
